<template>
	<BasePopover
		:id="$options.name"
		placement="top"
		:status.sync="status"
		:target-id="targetId"
	>
		<template #title>
			<div class="title">
				<span>{{ $t("Informations de mon entreprise") }}</span>
				<span class="float-right">{{ `${current_popover_showed}/${total_popovers_to_show}` }}</span>
			</div>
		</template>

		<template #default>
			<p class="label grey-color">
				{{ $t("Afficher votre RIB sur votre {documentType} vous permet d’être payé plus facilement.", { documentType: $t(documentType) }) }}
			</p>

			<hr />

			<b-form-group class="label" :label="$t('Nom')" label-cols="3">
				<b-form-input v-model="name" class="input grey-border w-100" />
			</b-form-group>

			<b-form-group class="label" :label="$t('IBAN')" label-cols="3">
				<b-form-input v-model="iban" class="input grey-border w-100" />
			</b-form-group>

			<b-form-group class="label" :label="$t('BIC')" label-cols="3">
				<b-form-input v-model="bic" class="input grey-border w-100" />
			</b-form-group>

			<p class="label grey-color text-center"> {{ $t("Validez sans rien remplir pour passer l’étape.") }} </p>

			<s-button type="" @click="onSubmit"> {{ $t("Enregistrer") }} </s-button>
		</template>
	</BasePopover>
</template>

<script>
	import { query } from "sinao-corejs";
	import { mapState } from "vuex";

	export default {
		name: "PopoverBankDetails",
		props: {
			targetId: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				name: null,
				iban: null,
				bic: null
			};
		},
		computed: {
			...mapState({
				appId: state => state.app.id,
				pageType: state => state.page.type,
        total_popovers_to_show: state => state.onboarding.total_popovers_to_show,
        current_popover_showed: state => state.onboarding.current_popover_showed
			}),
			documentType() {
				return this.pageType === "invoices" ? "facture" : "devis";
			},
			status: {
				get() {
					return this.$store.state.onboarding.showPopoverBankDetails;
				},
				set(value) {
					this.$store.commit("showPopoverBankDetails", value);
				}
			}
		},
		methods: {
			onSubmit() {
				const { appId, name, iban, bic } = this;

				if (name && iban && bic) {
					query({
						operationId: "app.documents.sales.bankdetails.create",
						params: {
							appId
						},
						data: { name, iban, bic }
					});

					this.$store.commit("bankdetails", {
						name,
						iban,
						bic,
						new: true
					});
				}

				this.next();
			},
			next() {
				query({
					operationId: "app.settings.update",
					params: {
						appId: this.appId
					},
					data: {
						settings: {
							"installation.onboarding.showPopoverBankDetails": 1,
							"installation.profile-onboarding": 1,
              "installation.onboarding-app.rib": 1
						}
					}
				});

				this.status = false;
        this.$store.commit("setPopovers", { key: "showPopoverBankDetails", value: false });
        this.$nextTick(() => {
          this.$store.dispatch('setNextOpenedPopover');
          this.$store.dispatch('incrementCurrentPopoverShowed');
        });
			}
		}
	};
</script>

<style lang="scss"></style>
